export default __webpack_public_path__ + "119942ed23ecb93bc7cdd1ad12e08a45.png";